// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.asset-number {
    margin-right: 10px !important;
    display: inline-flex;
    margin-top: 5px;
}
.asset-header-wo {
    height: 40px; 
    display: inline-block; 
    margin-top: 5px;
    margin-right: 10px;
}
:host ::ng-deep .p-checkbox {
    position: unset !important;
}
:host ::ng-deep input[type=text] {
    font-weight: normal !important;
}


`, "",{"version":3,"sources":["webpack://./src/app/select-work-order/select-work-order.component.css"],"names":[],"mappings":"AAAA;IACI,6BAA6B;IAC7B,oBAAoB;IACpB,eAAe;AACnB;AACA;IACI,YAAY;IACZ,qBAAqB;IACrB,eAAe;IACf,kBAAkB;AACtB;AACA;IACI,0BAA0B;AAC9B;AACA;IACI,8BAA8B;AAClC","sourcesContent":[".asset-number {\r\n    margin-right: 10px !important;\r\n    display: inline-flex;\r\n    margin-top: 5px;\r\n}\r\n.asset-header-wo {\r\n    height: 40px; \r\n    display: inline-block; \r\n    margin-top: 5px;\r\n    margin-right: 10px;\r\n}\r\n:host ::ng-deep .p-checkbox {\r\n    position: unset !important;\r\n}\r\n:host ::ng-deep input[type=text] {\r\n    font-weight: normal !important;\r\n}\r\n\r\n\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
